import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DataRetentionPolicies = () => {
  const mockPolicies = [
    {
      id: 1,
      dataType: 'User Activity Logs',
      retentionPeriod: 90,
      regulationType: 'GDPR',
      autoDeleteEnabled: true,
      lastCleanup: new Date()?.toISOString(),
      recordsDeleted: 1247
    },
    {
      id: 2,
      dataType: 'Payment Records',
      retentionPeriod: 2555,
      regulationType: 'PCI DSS',
      autoDeleteEnabled: false,
      lastCleanup: null,
      recordsDeleted: 0
    }
  ];

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-heading font-semibold text-foreground">Data Retention Policies</h3>
        <Button variant="default" size="sm">
          <Icon name="Plus" size={16} className="mr-2" />
          Add Policy
        </Button>
      </div>
      <div className="space-y-4">
        {mockPolicies?.map((policy) => (
          <div key={policy?.id} className="p-4 border border-border rounded-lg">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h4 className="text-sm font-medium text-foreground mb-1">{policy?.dataType}</h4>
                <p className="text-xs text-muted-foreground">Regulation: {policy?.regulationType}</p>
              </div>
              <span
                className="px-2 py-1 rounded text-xs font-medium"
                style={{
                  backgroundColor: policy?.autoDeleteEnabled ? 'var(--color-success)15' : 'var(--color-warning)15',
                  color: policy?.autoDeleteEnabled ? 'var(--color-success)' : 'var(--color-warning)'
                }}
              >
                {policy?.autoDeleteEnabled ? 'Auto-Delete ON' : 'Manual'}
              </span>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              <div>
                <p className="text-xs text-muted-foreground">Retention Period</p>
                <p className="text-sm font-medium text-foreground">{policy?.retentionPeriod} days</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Last Cleanup</p>
                <p className="text-sm font-medium text-foreground">
                  {policy?.lastCleanup ? new Date(policy?.lastCleanup)?.toLocaleDateString() : 'Never'}
                </p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Records Deleted</p>
                <p className="text-sm font-medium text-foreground">{policy?.recordsDeleted?.toLocaleString()}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DataRetentionPolicies;